import classes from './Header.module.css';
import { Fragment, useEffect, useState } from 'react';
import { NavLink, useParams } from 'react-router-dom';

// IMPORT DATA
import { globals } from '../../data/global-vars';

// IMPORT IMAGES
import logo_white from '../../assets/company_sources/logo_white.png';
import skoda_logo from '../../assets/company_sources/skoda_logo.png';
import womo_logo from '../../assets/company_sources/womo_logo.png';

// IMPORT FONTAWESOME ICONS
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBarsStaggered, faXmark } from '@fortawesome/free-solid-svg-icons';

// IMPORT OWN COMPONENTS
import { motion } from 'framer-motion';

// IMPORT OWN COMPONENTS
import BrandSwitch from './BrandSwitch';
import Navigation from './Navigation';

function Header() {
  const params = useParams();
  const page = params.page;

  // set brand if no brand given
  let brand = params.brand;
  let primeColor = null;
  if (!brand) {
    primeColor = globals.BRANDS.VW.primeColor;
    brand = globals.BRANDS.VW.url;
  }

  // set primecolor according to brand
  Object.values(globals.BRANDS).map((item) => {
    if (item.url === brand) {
      primeColor = item.primeColor;
    }
    return null;
  });

  // set logos according to brand / page
  function setLogoHandler() {
    if (page === globals.PAGES.WOHNMOBILE.url) {
      return { logo: womo_logo, logoStyle: classes.womo_logo };
    } else {
      if (brand === globals.BRANDS.SKODA.url) {
        return { logo: skoda_logo, logoStyle: classes.skoda_logo };
      } else {
        return { logo: logo_white, logoStyle: classes.logo };
      }
    }
  }
  const [logo, setLogo] = useState(setLogoHandler().logo);
  const [logoStyle, setLogoStyle] = useState(setLogoHandler().logoStyle);

  const [isTransitioning, setIsTransitioning] = useState(true);
  useEffect(() => {
    setIsTransitioning(true);
    setLogo(setLogoHandler().logo);
    setLogoStyle(setLogoHandler().logoStyle);

    const transitionTimeout = setTimeout(() => {
      setIsTransitioning(false);
    }, 300); // Übergangszeit in Millisekunden

    return () => {
      clearTimeout(transitionTimeout);
    };
  }, [brand, page]);

  // var and functions for navigation
  const [showNav, setShowNav] = useState(false);
  function toggleNav() {
    setShowNav(!showNav);
  }
  function closeNav() {
    if (showNav) setShowNav(false);
  }

  return (
    <Fragment>
      <div
        className={classes.headerBanner}
        style={{ backgroundColor: primeColor }}
      >
        <div className={classes.container}>
          <div className={` ${classes.left} ${'noSelect'}`}>
            <motion.div
              whileTap={{ scale: 0.94 }}
              onClick={toggleNav}
              className={`${showNav && classes.active} ${classes.navIcon}`}
              style={{ backgroundColor: primeColor }}
            >
              <FontAwesomeIcon icon={!showNav ? faBarsStaggered : faXmark} />
            </motion.div>
            {showNav && (
              <motion.div
                whileTap={{ scale: 0.94 }}
                onClick={toggleNav}
                className="text-[30px] top-[12.5px] right-[10px] fixed z-[200] cursor-pointer transition-all duration-300 text-black min-[480px]:hidden"
              >
                <svg
                  className="h-6 w-6 text-[var(--text-color)]"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  strokeWidth="2"
                  stroke="currentColor"
                  fill="none"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <path stroke="none" d="M0 0h24v24H0z" />{' '}
                  <line x1="18" y1="6" x2="6" y2="18" />{' '}
                  <line x1="6" y1="6" x2="18" y2="18" />
                </svg>
              </motion.div>
            )}
            <Navigation
              show={showNav}
              primeColor={primeColor}
              onHide={closeNav}
            />
          </div>
          <BrandSwitch header />
          <div
            className={`absolute right-0 top-[50%] translate-y-[-50%] select-none`}
          >
            <NavLink exact to={`/${brand}/${globals.PAGES.STARTSEITE.url}/`}>
              <img
                className={`${logoStyle} ${
                  isTransitioning && classes.transitioning
                }`}
                src={logo}
                alt={'Logo Autohaus Rainer Seyfarth'}
              />
            </NavLink>
          </div>
        </div>
      </div>
      <div style={{ marginTop: '15px' }}>
        <BrandSwitch />
      </div>
    </Fragment>
  );
}

export default Header;
